export default __webpack_public_path__ + "dcb583d9def8308113fc929e41105053.ttf";